const AboutMe = () => {
    return ( 
        <div>
        <h1 className="me">About me</h1>
        <div>
            <p className="article">
                Hello, my name is Yahaya Abdulrazaq Omeiza.
I am a postgraduate student (Masters) in Computer Science at the Federal University of Technology, Minna.

I obtained my High School Certificate in 2017 from Teacher’s College, after which I enrolled in the same year for my Bachelor’s degree in Mathematics. I successfully graduated in 2023 and completed my National Youth Service Corps (NYSC) in 2024.

Alongside my academic journey, I developed a strong passion for programming and technology. I began with HTML, CSS, and JavaScript, and have since gained foundational knowledge in Java, Python, LaTeX, and MATLAB.

Currently, I work as a Quality Assurance Engineer at Ichiem Telecommunication Company, where I specialize in ensuring the functionality, reliability of fiber cable and efficiency of both web and mobile applications. Over time, I have advanced into Quality Assurance Automation Engineering, leveraging automated testing to detect bugs early and optimize performance.

One of my notable projects involved developing a Python automation script that generates KML files for Google Earth. The script automatically places waypoints every 200 meters along a 500 km path, combining geospatial computation (using latitude/longitude and distance formulas) with automated file generation. This solution has significantly improved my organization’s efficiency, reduced costs, and delivered highly accurate results for visualization in Google Earth.

Beyond academics and work, I enjoy playing chess, where I am registered under FIDE ID: 8523606 (free to check).

In conclusion, I am passionate about technology, automation, and problem-solving. Please feel free to connect with me for opportunities, collaborations, or knowledge sharing.
            </p>
        </div>
        </div>
     );
}
 
export default AboutMe;